/* Black Horse Supplements — cart page scripts (v1.4).
   Loaded on the cart template only (snippets/bhs-head-meta.liquid). */

/* 1) Confirm before removing an item — BHS design (brown header, gold badge) */
(function () {
  var dialog, nameEl, imgEl, cancelBtn, okBtn, pending = null, allowNext = false;

  function build() {
    if (dialog) return;
    dialog = document.createElement('div');
    dialog.className = 'bhs-confirm';
    dialog.hidden = true;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'bhs-confirm-title');
    dialog.innerHTML =
      '<div class="bhs-confirm__box">' +
      '<div class="bhs-confirm__head"><span class="bhs-confirm__icon" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>' +
      '</span><h2 class="bhs-confirm__title" id="bhs-confirm-title">Remove from cart?</h2></div>' +
      '<div class="bhs-confirm__body"><div class="bhs-confirm__item"><img class="bhs-confirm__img" alt="" hidden>' +
      '<p class="bhs-confirm__name"></p></div>' +
      '<div class="bhs-confirm__actions">' +
      '<button type="button" class="bhs-confirm__btn bhs-confirm__btn--cancel">Keep item</button>' +
      '<button type="button" class="bhs-confirm__btn bhs-confirm__btn--ok">Remove</button>' +
      '</div></div></div>';
    document.body.appendChild(dialog);
    nameEl = dialog.querySelector('.bhs-confirm__name');
    imgEl = dialog.querySelector('.bhs-confirm__img');
    cancelBtn = dialog.querySelector('.bhs-confirm__btn--cancel');
    okBtn = dialog.querySelector('.bhs-confirm__btn--ok');
    cancelBtn.addEventListener('click', close);
    okBtn.addEventListener('click', function () {
      var el = pending;
      close();
      if (!el) return;
      allowNext = true;
      el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      allowNext = false;
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !dialog.hidden) close(); });
  }
  function open(removeEl) {
    build();
    var row = removeEl.closest('.cart-item');
    var item = row ? row.querySelector('.cart-item__name') : null;
    var img = row ? row.querySelector('img.cart-item__image, .cart-item__media img') : null;
    var src = img ? (img.currentSrc || img.getAttribute('src') || '') : '';
    nameEl.textContent = item ? item.textContent.trim() : '';
    if (src) { imgEl.src = src; imgEl.hidden = false; } else { imgEl.removeAttribute('src'); imgEl.hidden = true; }
    pending = removeEl;
    dialog.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    cancelBtn.focus();
  }
  function close() {
    if (!dialog) return;
    dialog.hidden = true;
    document.documentElement.style.overflow = '';
    pending = null;
  }
  document.addEventListener('click', function (e) {
    var remove = e.target && e.target.closest ? e.target.closest('cart-remove-button') : null;
    if (!remove || allowNext) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    open(remove);
  }, true);
})();

/* 2) Note under the subtotal: orders are charged in US dollars */
(function () {
  var HTML = '<strong>We process all orders in USD.</strong> Prices shown in other currencies are estimates; your card or PayPal is charged in US dollars at checkout.';
  var timer = null;
  function place() {
    if (document.querySelector('.bhs-currency-note')) return;
    var totals = document.querySelector('.cart__footer .totals');
    if (!totals) return;
    var note = document.createElement('p');
    note.className = 'bhs-currency-note';
    note.innerHTML = HTML;
    totals.insertAdjacentElement('afterend', note);
  }
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; place(); }, 200);
  }
  function init() {
    place();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
